import { TemplateDefaults } from "../../../library-templates/TemplateDefaults";
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { HTMLEditor } from "../../dom-tools/HTMLEditor";
import { RegExpUtility } from "../../text/RegExpUtility";

export class CopyFill
{
  static readonly attribute = new ElementAttribute( "-copy--fill" );
  static readonly target = new ElementAttribute( "-copy--fill--target" );
  static readonly source = new ElementAttribute( "-copy--fill--source" );
  static readonly mode   = new ElementAttribute( "-copy--fill--mode" );
  static readonly noBreaks = new ElementAttribute( "-copy--fill--no--breaks" );

  static applyOnDocument()
  {
    CopyFill.attribute.forEachInDoc( e => this.applyOnElement( e ) );
  } 

  static removeBreaks( innerHTML:string )
  {
    let temp = ElementType.div.create(); 
    temp.innerHTML = innerHTML;
    let breaks = HTMLEditor.filterChildren( temp, e => ElementType.break.is( e as Element ) );

    breaks.forEach(
      ( br )=>
      {
        let spaceNode = document.createTextNode( " " );
        temp.replaceChild( spaceNode, br );
      } 
    );

    return temp.innerHTML;
  }

  static addSource( sourceSelectorElement:Element, parent:Element, values:Map<string,string> )
  {
    let source = CopyFill.source.from( sourceSelectorElement );

    if ( ! source )
    {
      return;
    }

    let sourceElement = parent.querySelector( source );

    if ( ! sourceElement )
    {
      return;
    }

    let innerHTML = sourceElement.innerHTML;  

    values.set( source, innerHTML );
 
  }


  static applyOnElement( e:Element )
  {

    let sourceValues = new Map<string,string>();

    CopyFill.addSource( e, e, sourceValues );
    

    CopyFill.target.forAll(
       e, targetInstruction =>
      {
        let targetElement = e.querySelector( CopyFill.target.from( targetInstruction ) );

        if ( ! targetElement )
        {
          return;
        }

        CopyFill.addSource( targetInstruction, e, sourceValues );

        let mode =  CopyFill.mode.from( targetInstruction, CopyFill.mode.from( e ) );

        let num = 1;

        if ( mode && mode.startsWith( "repeat:" ) )
        {
          let numericValues = mode.replace( "repeat:", "" );
          num = RegExpUtility.parseNumbers( numericValues, [ 1 ] )[ 0 ];
        }
        
        let source = CopyFill.source.from( targetInstruction, CopyFill.source.from( e ) );
        let sourceValue = sourceValues.get( source );

        if ( CopyFill.noBreaks.in( targetInstruction ) )
        {
          sourceValue = CopyFill.removeBreaks( sourceValue );
        }

        let output = [];

        for ( let i = 0; i < num; i++ )
        {
          output.push( sourceValue ); 
        }

        targetElement.innerHTML = output.join( "" );

      }
    
    )

    
  }
}